import { NgModule } from '@angular/core';
import { Routes,
     RouterModule } from '@angular/router';
import { LeadNoticationDetailComponent } from './lead-notication-detail';


const routes: Routes = [
  {
    path: '',
    component: LeadNoticationDetailComponent,
    data: {
      title: 'Lead'
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class NotificationRotingModule {}



// WEBPACK FOOTER //
// /home/ec2-user/jenkins/workspace/new-roamingse/prod/roamingse-frontend/src/app/views/notification-detail/notication-detail-routing.ts